import React from 'react'
import { View, ViewStyle, TextStyle, Switch } from 'react-native'
import { Header, color, Text, RadioGroupWeb as RadioGroup, iconArrowBack } from '@trivie/ui-mobile'
import { useStores } from '@trivie/core'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router'

export const PostsCommentsScreen = observer(() => {
  const { userStore } = useStores()
  const { user } = userStore
  const history = useHistory()

  if (!user) {
    return null
  }

  const { user_comm_settings } = user

  return (
    <View testID="PostsCommentsScreen" style={FULL}>
      <div style={CONTAINER}>
        <Header
          leftIcon={iconArrowBack}
          onLeftPress={() => history.goBack()}
          center
          style={HEADER}
          titleStyle={HEADER_TITLE}
          headerTx="Settings.Notifications.postsComments"
        />

        <fieldset style={FIELDSETS}>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <View style={{ display: 'flex', flexDirection: 'column' }}>
              <Text variant="label" tx="Settings.Notifications.likes" />
              <Text variant="body2" tx="" style={{ color: color.shade50 }} />
            </View>
            <Switch
              // @ts-ignore
              dataSet={{ qat: `like_notification_toggle` }}
              accessible
              accessibilityRole="switch"
              accessibilityLabel="[Feed Activity Post&Comments]"
              trackColor={{ true: color.green, false: color.darkenGrey }}
              thumbColor="white"
              value={user_comm_settings?.push_notify_likes || false}
              onValueChange={(value) => {
                userStore.setUserCommSettings({
                  push_notify_likes: value,
                })
              }}
            />
          </View>
        </fieldset>
      </div>
    </View>
  )
})

/**
 * Styling
 */
const FULL: ViewStyle = { flex: 1 }
const CONTAINER: React.CSSProperties = {
  backgroundColor: color.white,
}
const FIELDSETS: React.CSSProperties = { padding: 0, border: 'none' }
const HEADER_TITLE: TextStyle = { fontSize: 24, color: color.black }
const HEADER: ViewStyle = { marginBottom: 12 }
